import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../redux/actions'
import { centsToText } from '../../services/MoneyHelper'

import Interface from '../../components/Interface'

import detectBrowserLanguage from 'detect-browser-language'
import WhatsAppShopDoubt from '../../components/WhatsAppShopDoubt'
import Loader from 'react-loader-spinner'
import { FiFileText } from 'react-icons/fi'
import moment from 'moment'

const styles = {
  noServiceBillingFound: {
    color: '#6d357b',
    fontSize: '20px',
    textAlign: 'center',
    paddingTop: '20px'
  },
  checkoutButton: {
    backgroundColor: '#1f8408',
    color: '#ffffff',
    cursor: 'pointer',
    textAlign: 'center',
    borderRadius: '16px',
    boxShadow: 'rgba(32, 3, 61, 0.55) 0px 4px 4px',
    height: '30px',
    fontWeight: 'bold',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}

const renderLoading = () => (
  <div style={{ position: 'absolute', top: 100, left: '50%', transform: 'translate(-50%, 0)' }}>
    <Loader
      type='TailSpin'
      color='#6d357b'
      height='50'
      width='50'
    />
  </div>
)

class ServiceBillingsList extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isLoading: true,
      language: 1,
      serviceBillings: this.props.allBillings
    }
  }

  componentWillMount () {
    if (!localStorage.getItem('language')) {
      if (detectBrowserLanguage() === 'pt-BR' || detectBrowserLanguage() === 'pt-PT' || detectBrowserLanguage() === 'pt' || detectBrowserLanguage().slice(0, 2) === 'pt') {
        this.setState({ language: 0 })
        localStorage.setItem('language', '0')
      }
      if (detectBrowserLanguage().slice(0, 2) === 'es') {
        this.setState({ language: 2 })
        localStorage.setItem('language', '2')
      }
    } else {
      this.setState({ language: localStorage.getItem('language') - '0' })
    }

    this.setState({ isLoading: false })
  }

  goBack = () => {
    if (this.props.location.state && this.props.location.state.fromCheckout) {
      return this.props.history.push('/')
    }

    return this.props.history.goBack()
  }

  handlePay = serviceBilling => {
    if (!this.props.payerInfo) {
      return this.props.history.push('/dados-cobranca', { serviceBilling })
    }

    if (!this.props.card || this.props.card.length === 0) {
      return this.props.history.push('/dados-cobranca/cartao/adicionar', { serviceBilling })
    }

    return this.props.history.push('/cobrancas/finalizar-compra', { serviceBilling })
  }

  renderStatus = status => {
    return status === 'canceled' ? 'CANCELADO'
      : status === 'paid' ? 'PAGO'
        : status === 'awaitingPayment' ? 'AGUARDANDO PAGAMENTO'
          : status === 'created' ? 'AGUARDANDO APROVAÇÃO'
            : status === 'refunded' ? 'REEMBOLSADO'
              : 'VENCIDO'
  }

  renderPriceByInstallments = serviceBilling => centsToText((Math.trunc((serviceBilling.price / serviceBilling.installments))))

  renderServiceBilling = serviceBilling => {
    return (
      <div key={serviceBilling.id} style={{display: 'flex', flexDirection: 'row', marginBottom: 32}}>
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', padding: 8 }}>
          <div>
            <p style={{fontSize: '20px', marginTop: 4, marginBottom: 2}}>
              <b>Serviço: {serviceBilling.clientService.consultantService.name}</b>
            </p>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
            <p style={{fontSize: '18px', marginTop: '4px', marginBottom: 0}}>
              Valor a ser pago: {centsToText(serviceBilling.price)}
            </p>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
            <p style={{fontSize: '18px', marginTop: '4px', marginBottom: 0}}>
              Número máximo de parcelas: {serviceBilling.maxInstallments}
            </p>
          </div>
          {serviceBilling.status === 'paid' && <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
            <p style={{fontSize: '18px', marginTop: '4px', marginBottom: 0}}>
              Pago em {serviceBilling.installments}x de {this.renderPriceByInstallments(serviceBilling)}
            </p>
          </div>}
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
            <p style={{fontSize: '18px', marginTop: '4px', marginBottom: 0}}>
              Situação: {this.renderStatus(serviceBilling.status)}
            </p>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
            <p style={{fontSize: '18px', marginTop: '4px', marginBottom: serviceBilling.status === 'awaitingPayment' ? undefined : 0}}>
              Vencimento da cobrança: {moment(serviceBilling.dueDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}
            </p>
          </div>
          {serviceBilling.status === 'awaitingPayment' ? <div style={styles.checkoutButton} onClick={() => this.handlePay(serviceBilling)}>
            Pagar via cartão
          </div> : null}
        </div>
      </div>
    )
  }

  renderServiceBillings = () => {
    return (
      <div>
        {this.state.serviceBillings && this.state.serviceBillings.length > 0 ? (
          this.state.serviceBillings.map(serviceBilling => {
            return this.renderServiceBilling(serviceBilling)
          })
        ) : (
          <div style={styles.noServiceBillingFound}>Nenhuma cobrança encontrada.</div>
        )
        }
      </div>
    )
  }

  renderContent = () => {
    return (
      <div style={{display: 'flex', flexDirection: 'column', height: 'calc(100vh - 50px)'}}>
        <div style={{ padding: '8px', display: 'flex', flexDirection: 'column', overflowY: 'scroll' }}>
          <div style={{display: 'flex', flexDirection: 'column', width: '100%', maxWidth: '720px', marginRight: 'auto', marginLeft: 'auto'}}>
            {this.renderServiceBillings()}
            <div style={{backgroundColor: 'rgba(148, 66, 138, 0.5)', height: '1px', width: '90%', margin: 'auto', marginTop: 16}} />
            <WhatsAppShopDoubt clientName={this.props.user.name} />
          </div>
        </div>
      </div>
    )
  }

  render () {
    return (
      <Interface
        title='Lista de Cobranças'
        history={this.props.history}
        showFooter={false}
        backgroundClass='shop-background'
        logoIcon={
          <FiFileText size='24'
            color='#94428a'
          />
        }
        customPadding={6}
        goBack={this.goBack}
      >
        {this.state.isLoading ? renderLoading() : this.renderContent()}
      </Interface>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.userReducer.user,
    card: state.productsReducer.card,
    payerInfo: state.productsReducer.payerInfo,
    allBillings: state.billingAndBlockStatusReducer.allBillings
  }
}

export default connect(mapStateToProps, actions)(ServiceBillingsList)



// WEBPACK FOOTER //
// ./src/containers/Shop/ServiceBillingList.js